import type { ThunkAction } from "redux-thunk";
import type { AnyAction } from "../../../redux/types";
import { loadCart } from "../../../Cart/api/cartQuoteCommonApi";
import type { RootState } from "../../../redux/store";
import { ADD_QTY, LOAD_CART_NONCART_PAGE } from "~/AddToCart/redux/cartAmounts/actionTypes";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export function loadCartAmounts(): ThunkResult<void> {
  return async (dispatch, getState) => {
    const data = await loadCart();
    if (data !== null) {
      dispatch({
        type: LOAD_CART_NONCART_PAGE,
        payload: data,
      });
    }
  };
}

export function addQuantity(productCode: string, packCode: string, amount: number, priceReference: string) {
  return {
    type: ADD_QTY,
    payload: {
      productCode,
      packCode,
      amount,
      priceReference,
    },
  };
}
